import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoginModal from './LoginModal';
import RegisterModal from './RegisterModal';
import ForgotPassword from './ForgotPassword';

const Header = ({ onLogoClick }) => {
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const dropdownRef = useRef(null);

  const isAdminPage = location.pathname === '/admin';

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowUserMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    logout();
    setShowUserMenu(false);
  };

  const switchToRegister = () => {
    setShowLoginModal(false);
    setShowRegisterModal(true);
  };

  const switchToLogin = () => {
    setShowRegisterModal(false);
    setShowLoginModal(true);
  };

  const showForgotPassword = () => {
    setShowLoginModal(false);
    setShowForgotPasswordModal(true);
  };

  const backToLogin = () => {
    setShowForgotPasswordModal(false);
    setShowLoginModal(true);
  };

  return (
    <>
      <header className="header">
        <div className="logo" onClick={onLogoClick || (() => navigate('/'))} style={{ cursor: 'pointer' }}>
          <img 
            src="/assets/logo/pakainow logo.png" 
            alt="PakaiNow AI" 
            className="logo-image"
          />
          {/* <div className="logo-text">
            <h1>PakaiNow AI</h1>
            <p>#WearTheFuture</p>
          </div> */}
        </div>
        <div className="header-actions">
          {isAuthenticated ? (
            <>
              <button className="btn btn-outline">
                ✨ {user?.credits || 0} Credits
              </button>
              <button 
                className="btn btn-outline"
                onClick={() => navigate('/my-videos')}
              >
                🎬 My Videos
              </button>
              <div className="user-menu-container" ref={dropdownRef}>
                <button 
                  className="btn btn-primary user-btn"
                  onClick={() => setShowUserMenu(!showUserMenu)}
                >
                  <span className="user-initial">
                      {user?.name?.charAt(0).toUpperCase() || '?'}
                    </span>
                  <span className="user-name">{user?.name || 'User'}</span>
                </button>
                {showUserMenu && (
                  <div className="user-dropdown">
                    <div className="user-info">
                      <p className="user-email">{user?.email}</p>
                      <p className="user-credits">Credits: {user?.credits || 0}</p>
                    </div>
                    {/* <button className="dropdown-item" onClick={() => setShowUserMenu(false)}>
                      👤 Profile
                    </button>
                    <button className="dropdown-item" onClick={() => {
                      navigate('/my-videos');
                      setShowUserMenu(false);
                    }}>
                      🎬 My Videos
                    </button>
                    <button className="dropdown-item" onClick={() => setShowUserMenu(false)}>
                      ⚙️ Settings
                    </button> */}
                    <div className="dropdown-divider"></div>
                    <button className="dropdown-item logout" onClick={handleLogout}>
                      🚪 Logout
                    </button>
                  </div>
                )}
              </div>
            </>
          ) : (
            <>
              <button 
                className="btn btn-outline"
                onClick={() => setShowLoginModal(true)}
              >
                Login
              </button>
              <button 
                className="btn btn-primary"
                onClick={() => setShowRegisterModal(true)}
              >
                Sign Up
              </button>
            </>
          )}
        </div>
      </header>

      <LoginModal 
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
        onSwitchToRegister={switchToRegister}
        onShowForgotPassword={showForgotPassword}
      />

      <RegisterModal 
        isOpen={showRegisterModal}
        onClose={() => setShowRegisterModal(false)}
        onSwitchToLogin={switchToLogin}
      />

      <ForgotPassword
        isOpen={showForgotPasswordModal}
        onClose={() => setShowForgotPasswordModal(false)}
        onBackToLogin={backToLogin}
      />
    </>
  );
};

export default Header;
